module.exports = __webpack_public_path__ + "medias/images/affiliate-pin.png";